// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import {Fragment} from "jsx-render";
import TopicList from "./TopicList.jsx";
import ProjectList from "./ProjectList.jsx";
import CopyButton from "../../common/components/CopyButton.jsx";
import IconButton from "../../common/components/IconButton.jsx";
import LoadingBox from "../../common/components/LoadingBox.jsx";
import Button from "../../common/components/Button.jsx";
import {ShadowContent} from "../../common/components/ShadowElements.jsx";
import classNames from "classnames";
import Data from "../../../../main/data/index.js";
import {attachModal, MODALS} from "../../../../lit-components/common/modals.js";
import Utils from "../../../../main/utils/index.js";
import Integration from "../../../integration/index.js";

/**
 * @param {Object}   props
 * @param {string}   props.annotationUuid
 * @param {function} props.calculateListHeights
 * @param {boolean}  props.canAddTopics
 * @param {boolean}  props.canEditTopics
 * @param {string}   props.copyButtonLabel
 * @param {number}   props.left
 * @param {function} props.onClickCopy
 * @param {function} props.onClickAddTopic
 * @param {function} props.onClickDeleteAnnotation
 * @param {function} props.onClickProject
 * @param {function} props.onClickSwitchBtn
 * @param {function} props.onClickTopic
 * @param {function} props.onClickHelp
 * @param {function} props.onClickDisable
 * @param {function} props.onKeyDownProjectTopicMenu
 * @param {Object}   props.project
 * @param {Array}    props.projects
 * @param {string}   props.projectTopicsUrl
 * @param {string}   props.selectedProjectUuid
 * @param {string}   props.selectedTopicUuid
 * @param {number}   props.top
 * @param {Array}    props.topics
 * @param {string|null} props.integration
 * @return {HTMLElement}
 */
const ProjectTopicMenuPanel = props => {
	const isUnsaved = !Data.app.isLoggedIn || !Data.app.me?.email;
	const onClickCreateAccount = async () => {
		if (!Data.app.isLoggedIn && Integration.isIntegration())
			await Data.app.createIntegrationAccount(Integration.name, Integration.getClientToken);

		attachModal(MODALS.INT_LOGIN);
	};

	const menu = (
		<ShadowContent
			className={classNames({
				"mode-topic-selection":              true,
				["integration-" + Integration.name]: Integration.isIntegration()
			})}
			id="project-topic-menu"
			onKeyDown={props.onKeyDownProjectTopicMenu}
			role="dialog"
			style={{
				position: "absolute",
				top:      props.top + "px",
				left:     props.left + "px"
			}}
		>
			{props.projects?.length > 1 && <Fragment>
				<div id="label-select-project">Select a project</div>
				{!props.annotationUuid
					&& <Fragment>
						<IconButton
							className="btn-project-switch"
							icon="aa-icon-chevron-light-down aa-icon-mask"
							onClick={props.onClickSwitchBtn}
							tooltipText="Switch Project"
						/>
						<LoadingBox
							message="Loading"
						/>
					</Fragment>
				}
			</Fragment>}
			{props.projects?.length > 0 && <ProjectList
				onClickProject={props.onClickProject}
				projects={props.projects}
				selectedProjectUuid={props.selectedProjectUuid}
			/>}
			<TopicList
				onClickTopic={props.onClickTopic}
				selectedTopicUuid={props.selectedTopicUuid}
				topics={props.topics}
			/>
			<div className="actions js-actions">
				{Integration.name === "proquest" && isUnsaved
					&& <span className="unsaved-indicator">[UNSAVED]</span>
				}
				<CopyOrDeleteButton
					annotationUuid={props.annotationUuid}
					copyButtonLabel={props.copyButtonLabel}
					onClickCopy={props.onClickCopy}
					onClickDeleteAnnotation={props.onClickDeleteAnnotation}
				/>

				<AddTopicButton
					canAddTopics={props.canAddTopics}
					onClickAddTopic={props.onClickAddTopic}
				/>

				{Integration.isIntegration() && <DisableButton
					onClickDisable={props.onClickDisable}
				/>}

				{Integration.isIntegration() && <HelpButton
					onClickHelp={props.onClickHelp}
				/>}

				{props.canEditTopics && props.projectTopicsUrl && <a
					className="aa-btn-ext-icon btn-actions link-actions js-btn-edit-topics"
					data-tippy-content="Edit Topics"
					target="_blank"
					href={props.projectTopicsUrl}
				>
					<i className="aa-icon-edit aa-icon-mask" />
				</a>}
			</div>

			{Integration.name === "proquest" && isUnsaved && <footer>
				{<section className="save-button-wrapper">
					<Button onClick={onClickCreateAccount} render="auth">Save Project</Button>
				</section>}
				<section className="msg-help">
					<div className="msg-sidebar-help-inner">
						<div className="msg-help-header">Research with <strong>PowerNotes</strong></div>
						<ul>
							<li>
								<img
									alt="PowerNotes logo"
									src={Utils.Common.imgPath("proquest/u46.svg")}
								/>
								<span>Create <strong>up to 5</strong> Congressional Research projects.</span>
							</li>
							<li>
								<img
									alt="PowerNotes logo"
									src={Utils.Common.imgPath("proquest/u35.svg")}
								/>
								<span>Highlight text or add a new topic.</span>
							</li>
							<li>
								<img
									alt="PowerNotes logo"
									src={Utils.Common.imgPath("proquest/u38.svg")}
								/>
								<span>Add notes to your highlights.</span>
							</li>
							<li>
								<img
									alt="PowerNotes logo"
									src={Utils.Common.imgPath("proquest/u42.png")}
								/>
								<span>Work with your project in the <strong>PowerNotes sidebar</strong>.</span>
							</li>
						</ul>
					</div>
					<div className="msg-help-footer">
						New to PowerNotes? <a
							href={Data.app.config?.urls.promo + "resources/help-support"}
							target="_blank"
						>Learn more</a>
					</div>
				</section>
			</footer>}
		</ShadowContent>
	);

	props.calculateListHeights(menu);

	return menu;
};

export default ProjectTopicMenuPanel;

/**
 * @param {Object}   props
 * @param {boolean}  props.canAddTopics
 * @param {function} props.onClickAddTopic
 * @return {HTMLElement}
 */
export const AddTopicButton = props => {
	if (props.canAddTopics) {
		return (
			<button
				className="aa-btn-ext-icon btn-actions js-btn-show-add-topic"
				data-tippy-content="Add Topic"
				onClick={props.onClickAddTopic}
			>
				<i className="aa-icon-add aa-icon-mask"/>
			</button>
		);
	} else
		return null;
};

/**
 * @param {Object}   props
 * @param {function} props.onClickDisable
 * @return {HTMLElement}
 */
export const DisableButton = props => {
	return (
		<button
			className="aa-btn-ext-icon btn-actions js-btn-show-help-project"
			data-tippy-content="Disable PowerNotes"
			onClick={props.onClickDisable}
		>
			<i className="aa-icon-disable aa-icon-mask"/>
		</button>
	);
};

/**
 * @param {Object}   props
 * @param {function} props.onClickHelp
 * @return {HTMLElement}
 */
export const HelpButton = props => {
	return (
		<button
			className="aa-btn-ext-icon btn-actions js-btn-show-help-project"
			data-tippy-content="Help"
			onClick={props.onClickHelp}
		>
			<i className="aa-icon-help aa-icon-mask"/>
		</button>
	);
};

/**
 * @param {Object}   props
 * @param {boolean}  props.canEditTopics
 * @param {string}   props.copyButtonLabel
 * @param {function} props.onClickCopy
 * @param {function} props.onClickDeleteAnnotation
 * @return {HTMLElement}
 */
const CopyOrDeleteButton = props => {
	if (props.annotationUuid && props.canEditTopics) {
		return (
			<button
				className="aa-btn-ext-icon btn-actions js-btn-delete"
				data-tippy-content="Delete Highlight"
				onClick={props.onClickDeleteAnnotation}
			>
				<i className="aa-icon-trash aa-icon-mask"/>
			</button>
		);
	} else {
		return <CopyButton
			label={props.copyButtonLabel}
			onClick={props.onClickCopy}
		/>;
	}
};
